/**
 * Blog Component Theme
 */

export const blogStyles = {
  parts: ['root', 'headerMedia', 'content'],
  baseStyle: {
    root: {
      maxWidth: '1440px',
      marginX: 'auto',
      paddingX: {base: '20px', lg: '80px'},
      width: '100%',
    },
    headerMedia: {
      'mb': 8,
      '& img': {
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
      },
    },
    content: {
      'py': {base: 8, md: 12},
      '& p': {
        mb: 4,
        lineHeight: 'tall',
      },
      '& h2': {
        fontSize: 'xl',
        fontWeight: 'bold',
        mt: 8,
        mb: 4,
      },
      '& h3': {
        fontSize: 'lg',
        fontWeight: 'semibold',
        mt: 6,
        mb: 3,
      },
      '& ul, & ol': {
        pl: 6,
        mb: 4,
      },
      '& li': {
        mb: 2,
      },
      '& a': {
        color: 'blue.600',
        textDecoration: 'underline',
      },
      '& blockquote': {
        borderLeftWidth: '4px',
        borderLeftColor: 'gray.200',
        pl: 4,
        py: 2,
        my: 6,
        fontStyle: 'italic',
        color: 'gray.600',
      },
    },
  },
};
